<template>
    <div class="container-fluid">
        <h1>{{$t('menuItemErrorlog')}}</h1>
        <br />
        <span>{{$t('errorlogPageText')}}</span>
        <br />
        <br />
        <div class="col-md-10">
            <div class="form-group row">
                <!-- Start date of latest errorlog -->
                <label class="col-md-2" for="datepicker_releasedate">{{$t('dateTo')}}</label>
                <div class="col-md-3">
                    <!-- Datetimepicker -->
                    <b-form-input id="datepicker_releasedate"
                                  type="date"
                                  v-model="startDateErrorLogs"></b-form-input>
                </div>
                <div class="col-md-1"></div>
                <!-- Number of latest errorlog rules -->
                <label class="col-md-2" for="numberOfErrorlogs">{{$t('errorlogNumberOfRecords')}}</label>
                <div class="col-md-3">
                    <x-number :id="'numberOfErrorlogs'"
                              :name="'numberOfErrorlogs'"
                              placeholder="10"
                              :step="1"
                              :minValue="1"
                              :maxValue="50"
                              v-model="numberOfErrorlogs">
                    </x-number>
                </div>
                <div class="col-md-1"></div>
            </div>
            <!-- Button row -->
            <div class="form-group row">
                <base-button :id="`ErrorlogSelectRecords`"
                             :name="`ErrorlogSelectRecords`"
                             :class="`btn-space`"
                             variant="primary"
                             size="sm"
                             @click="$_updateErrorLogs"
                             :text="$t('errorlogSelectRecords')">
                </base-button>
                <base-button :id="`ErrorlogUndoSelection`"
                             :name="`ErrorlogUndoSelection`"
                             :class="`btn-space`"
                             variant="primary"
                             size="sm"
                             @click="$_resetErrorLogs"
                             :text="$t('errorlogUndoSelection')">
                </base-button>
            </div>
            <div class="form-group row">
                <!-- Overview Table last 10 rows -->
                <b-table striped
                         hover
                         small
                         outlined
                         bordered
                         v-show="(this.errorlogLoaded && this.errorlogLatest.length > 0)"
                         :tbody-tr-class="$_rowClass"
                         :items="errorlogLatest"
                         :fields="fields">
                    <template v-slot:cell(show_error)="row">
                        <base-button :id="`OpenError`"
                                     :name="`OpenError`"
                                     :class="`mr-2`"
                                     size="sm"
                                     @click="$_showErrorMessage(row.item)"
                                     :text="$t('openError')">
                        </base-button>
                    </template>
                    <template v-slot:cell(show_stack)="row">
                        <base-button :id="`OpenStackTrace`"
                                     :name="`OpenStackTrace`"
                                     :class="`mr-2`"
                                     size="sm"
                                     @click="$_showStackTrace(row.item)"
                                     :text="$t('openStackTrace')">
                        </base-button>
                    </template>
                </b-table>
                <!-- Error modal met error details -->
                <div v-show="errorLogOpen"
                     class="modal">
                    <div class="modal-dialog" style="width: 1050px">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{$t('errorDetails')}}</h4>
                                <b-button-close id="`iconCloseModalForm`"
                                                data-dismiss="modal"
                                                aria-hidden="true"
                                                @click="$_closeErrorModal">
                                </b-button-close>
                            </div>
                            <div class="modal-body">
                                <x-textarea :rows="10"
                                            v-model="errorText"
                                            :hasResizeHandle="true">
                                </x-textarea>
                            </div>
                            <div class="modal-footer">
                                <base-button id="`btnCloseModalForm`"
                                             variant="primary"
                                             data-dismiss="modal"
                                             @click="$_closeErrorModal"
                                             :text="$t('btnCloseLabel')">
                                </base-button>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <!-- Card for cleaning last month's ErrorLog-->
                <b-card no-body
                        header-tag="header"
                        footer-tag="footer">
                    <template v-slot:header>
                        <span class="font-weight-bold">{{$t('logEmptyMonth')}}</span>
                    </template>
                    <b-card-body>
                        <!-- Button for cleaning last month's ErrorLog -->
                        <b-card-text>{{$t('logEmptyOlderMonth')}}</b-card-text>
                        <base-button :id="`ClearLastMonthErrorLog`"
                                     :name="`ClearLastMonthErrorLog`"
                                     size="sm"
                                     @click="$_clearLastMonthErrorLog"
                                     :text="$t('logEmpty')"
                                     :disabled="$_buttonClearLastMonthErrorLogDisabled()"
                                     :iconClass="`fa fa-trash-alt`">
                        </base-button>
                    </b-card-body>
                    <template v-slot:footer>
                        <span>{{$t('state')}}: {{statusErrorLogClearLastMonth}}</span>
                    </template>
                </b-card>
                <br />
                <br />
                <!-- Card for cleaning the entire ErrorLog -->
                <b-card no-body
                        header-tag="header"
                        footer-tag="footer">
                    <template v-slot:header>
                        <span class="font-weight-bold">{{$t('logEmpty')}}</span>
                    </template>
                    <b-card-body>
                        <!-- Button for cleaning the entire ErrorLog -->
                        <b-card-text>{{$t('logEmptyTable')}}</b-card-text>
                        <base-button :id="`ClearErrorLog`"
                                     :name="`ClearErrorLog`"
                                     size="sm"
                                     @click="$_clearErrorLog"
                                     :text="$t('logEmpty')"
                                     :iconClass="`fa fa-trash-alt`">
                        </base-button>
                    </b-card-body>
                    <template v-slot:footer>
                        <span>{{$t('state')}}: {{statusErrorLogClear}}</span>
                    </template>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import BaseButton from '../../components/BaseComponents/base-button.vue';
    import XTextarea from '../../components/BaseComponents/x-textarea.vue';
    import XNumber from '../../components/BaseComponents/x-number.vue';
    import { nprogress } from '../../services/utilities';

    export default {
        name: 'Errorlog',

        mixins: [
            modalMixin
        ],

        components: {
            'base-button': BaseButton,
            'x-textarea': XTextarea,
            'x-number': XNumber
        },

        data() {
            return {
                startDateErrorLogs: '',
                numberOfErrorlogs: null,
                errorlogLatest: [],
                errorlogLoaded: false,
                errorText: '',
                errorLogOpen: false,
                statusErrorLogClearLastMonth: this.$t('statusNoRequestSent'),
                statusErrorLogClear: this.$t('statusNoRequestSent'),

                fields: [
                    {
                        key: 'id',
                        label: 'Id',
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'errorMessage',
                        label: this.$t('description'),
                        sortable: false,
                        formatter: value => {
                            return value.substring(0, 100);
                        },
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'displayTimestamp',
                        label: this.$t('timeStamp'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'show_error',
                        label: this.$t('error'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'show_stack',
                        label: this.$t('stacktrace'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'codeType',
                        label: 'Codetype',
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ]
            };
        },

        mounted() {
            // Fetch the errorlogs from db with default settings on initialization
            this.$_updateErrorLogs();
        },

        methods: {
            async $_updateErrorLogs() {
                nprogress.start();
                // If unset, date is empty string, back-end sets current date
                if (!this.startDateErrorLogs) {
                    this.startDateErrorLogs = '';
                }
                // If unset, number of records is 10
                if (!this.numberOfErrorlogs) {
                    this.numberOfErrorlogs = 10;
                }

                await this.$store.dispatch('useApiData', {
                    name: 'GetLatestErrorLog',
                    parameters: {
                        number: this.numberOfErrorlogs,
                        startDate: this.startDateErrorLogs
                    }
                }).then((result) => {
                    this.errorlogLatest = result.data;
                    this.errorlogLoaded = true;
                    this.errorlogLatest.forEach(function (errorLog) {
                        const dateTimeParts = errorLog.timestamp.split('T');
                        errorLog.displayTimestamp = `${dateTimeParts[0]} ${dateTimeParts[1].split('.')[0]}`;
                    });
                    nprogress.done();
                }, reason => {
                    nprogress.done();
                    // Error!
                    this.showToast({
                        title: this.$t('errorGetErrorLog'),
                        message: `${this.$t('errorGet')} ${this.$t('errorWas')} "${reason}"`,
                        variant: 'danger',
                        autoHideDelay: 5000
                    });
                });
            },
            $_resetErrorLogs() {
                // Clear ErrorLog
                this.errorlogLatest = [];
            },
            $_showStackTrace(errorlog) {
                this.errorText = errorlog.stacktrace;
                this.$_openErrorModal();
            },
            $_showErrorMessage(errorlog) {
                this.errorText = errorlog.errorMessage;
                this.$_openErrorModal();
            },
            // Show modal
            $_openErrorModal() {
                this.errorLogOpen = true;
            },
            // Hide modal
            $_closeErrorModal() {
                this.errorLogOpen = false;
                this.errorText = '';
            },
            // Clear ErrorLog last month
            $_clearLastMonthErrorLog() {
                this.msgBoxConfirm({
                    message: this.$t('errorLogConfirmClearLastMonth'),
                    title: this.$t('errorLogRemove'),
                    okVariant: 'danger'
                }).then(async (confirmed) => {
                    if (confirmed) {
                        this.statusErrorLogClearLastMonth = this.$t('statusRequestSent');
                        await this.$store.dispatch('useApiData', {
                            name: 'ClearErrorLogLastMonth'
                        }).then((result) => {
                            // Success
                            if (result.data) {
                                this.statusErrorLogClearLastMonth = this.$t('statusErrorLogRequestFinished');
                                this.$_updateErrorLogs();
                            } else {
                                this.statusErrorLogClearLastMonth = this.$t('statusErrorlogRequestFailed');
                            }
                        }, (reason) => {
                            // Error
                            this.showToast({
                                title: this.$t('errorCleanErrorLog'),
                                message: `${this.$t('checkFailedDueToError')} ${this.$t('errorWas')} "${reason}"`,
                                variant: 'danger',
                                autoHideDelay: 5000
                            });
                        });
                    }
                });
            },
            $_clearErrorLog() {
                this.msgBoxConfirm({
                    message: this.$t('errorLogConfirmClear'),
                    title: this.$t('errorLogRemove'),
                    okVariant: 'danger'
                }).then(async (confirmed) => {
                    if (confirmed) {
                        this.statusErrorLogClear = this.$t('statusRequestSent');
                        await this.$store.dispatch('useApiData', {
                            name: 'ClearErrorLog'
                        }).then((result) => {
                            // Success
                            if (result.data) {
                                this.statusErrorLogClear = this.$t('statusErrorLogRequestFinished');
                                this.$_updateErrorLogs();
                            } else {
                                this.statusErrorLogClear = this.$t('statusErrorlogRequestFailed');
                            }
                        }, (reason) => {
                            // Error
                            this.showToast({
                                title: this.$t('errorCleanErrorLog'),
                                message: `${this.$t('checkFailedDueToError')} ${this.$t('errorWas')} "${reason}"`,
                                variant: 'danger',
                                autoHideDelay: 5000,
                            });
                        });
                    }
                });
            },
            $_buttonClearLastMonthErrorLogDisabled() {
                return this.statusErrorLogClearLastMonth !== this.$t('statusNoRequestSent')
                    && this.statusErrorLogClearLastMonth !== this.$t('statusErrorLogRequestFinished');
            },
            $_buttonClearErrorLogDisabled() {
                return this.statusErrorLogClear !== this.$t('statusNoRequestSent')
                    && this.statusErrorLogClear !== this.$t('statusErrorLogRequestFinished');
            },
            $_rowClass() {
                return 'tablerow';
            }
        }
    };
</script>

<style scoped>
    .modal {
        display:block;
    }
    .btn-space {
        margin: 5px;
    }
    div.modal-body textarea {
        width: 100%;
    }

    .w-10 {
        width: 10% !important;
    }
    .w-15 {
        width: 15% !important;
    }
    .w-35 {
        width: 35% !important;
    }

    div.card {
        width: 100%;
        margin-top: 20px;
    }
</style>
